export default __webpack_public_path__ + "static/media/CoinGecko.9d8fbba5.png";